<section class="astrolorglist" *ngIf="astroList.length>0">
    <div class="container">
        <h2 class="heading">{{heading}}</h2>
        <div class="swiper mySwiper3">
            <div class="swiper-wrapper">
                <div class="swiper-slide" routerLink="/best-advisor/{{item?.profileUrl}}" *ngFor="let item of astroList">
                    <div class="profile-card item" routerLink="/best-advisor/{{item?.profileUrl}}">
                        <div class="">
                            <div class="image mt-2">
                                <img src="{{item?.profilePic?item?.profilePic:'/assets/icons/home-page/person.svg'}}"
                                    alt="Talk to Astrologers" class="profile-img">
                            </div>

                            <div class="name mt-3">
                                <span>{{item?.astrologerName}}</span>
                                <div class="verify" *ngIf="item?.isVerifiedByAp">
                                    <img src="/assets/icons/home-page/verify.svg" alt="">
                                </div>
                            </div>
                            <div class="specialization">
                                <p class="author_specialization">
                                    <span>{{item.specializationArea}}</span>
                                </p>
                            </div>
                            <div class="skill">
                                <p class="author_skill"> Skills:</p>
                                <div class="skill_Cards">
                                    <span class="skill_card" *ngFor="let item of item.expertiseArea | slice:0:2">{{item}}</span>
                                </div>
                            </div>
                            <div class="skill">
                                <p class="author_skill"> Certified:</p>
                                <div class="skill_Cards">
                                    <span class="skill_card certified_card" *ngFor="let item of item.expertiseArea | slice:0:2">{{item}}</span>
                                </div>
                            </div>
                            <div class="divider"></div>
                            <div class="rating">
                                <div class="avg_rating">
                                    <ngx-stars [readonly]="true" [color]="'#ffa400'" [size]="1" [maxStars]="5"
                                        [initialStars]="item?.averageRating"></ngx-stars>({{item.averageRating}})
                                </div>
                                <div class="review">
                                    <!-- <p> <i class="fa-regular fa-user"></i> 142 Reviews</p> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="swiper-button-next" ><img src="/assets/icons/home-page/slider-next_img.svg" alt=""></div>
            <div class="swiper-button-prev" ><img src="/assets/icons/home-page/slider-next_img.svg" alt=""></div>
        </div>
    </div>
</section>